import { redirect, createFileRoute } from '@tanstack/react-router';

/**
 * There is one calendar now. This path is kept because it is in notification
 * links, bookmarks and anything a customer has shared, and it lands on the same
 * screen it always did.
 */
export const Route = createFileRoute(
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/calendar'
)({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/dashboard/o/$orgId/c/$clientId/calendar', params });
  },
});
